module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('h1', {
    attrs: {
      "id": "pz9-1"
    }
  }, [_vm._v("\n\t\t\t\t\tTable of Contents ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter03#pz11-1"
    }
  }, [_c('b', [_vm._v("Acknowledgment ")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter05#pz15-1"
    }
  }, [_c('b', [_vm._v("Foreword")]), _vm._v(" by Jan and Richard Hughes ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "pz9-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#pz23-1"
    }
  }, [_c('b', [_vm._v("Introduction")]), _vm._v(" | Telling Our Stories ")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz9-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#pA4v",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Sermons")]), _vm._v(" | Hearing Our Voices"), _c('br'), _vm._v("\n(in chronological order)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#pz31-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kathy J. Pulley,")]), _vm._v(" “Living in the Kingdom,” Jer. 31:13–14; Luke 7:22"), _c('br'), _vm._v("\n\t\t\t\t\t   Brookline Church of Christ, Brookline, MA, 1984")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#pz37-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micki Pulleyking,")]), _vm._v(" “What Will We Do in Boston?” Luke 10:25–37; Acts 28:30"), _c('br'), _vm._v("\n\t\t\t\t\t   Brookline Church of Christ, Brookline, MA, 1987")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#pz45-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Elsie Carter Eyer,")]), _vm._v(" “Returning from Exile,” Isa. 40:1–11; Mark 1:1–18"), _c('br'), _vm._v("\n\t\t\t\t\t   Flagstaff Church of Christ, Flagstaff, AZ, 1991")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#pz51-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Carolyn Hunter,")]), _vm._v(" “Goods and the Greater Good,” Luke 16:19–31"), _c('br'), _vm._v("\n\t\t\t\t\t   Flagstaff Church of Christ, Flagstaff, AZ, 1992")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#pz57-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Katie Hays,")]), _vm._v(" “Mark 4:35–41—A Text for the Sunday after 9/11”"), _c('br'), _vm._v("\n\t\t\t\t\t   West Islip Church of Christ, West Islip, NY, 2001")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#pz65-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeanine Thweatt-Bates,")]), _vm._v(" “Perfect Righteousness,” Matt. 15:21–28"), _c('br'), _vm._v("\n\t\t\t\t\t   West Islip Church of Christ, West Islip, NY, 2005")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#pz73-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Beth Bowers,")]), _vm._v(" “Such as These,” Mark 10:13–16"), _c('br'), _vm._v("\n\t\t\t\t\t   Rochester College, Rochester Hills, MI, 2006")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#pz81-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kindalee Pfremmer DeLong,")]), _vm._v(" “Responding to the God of Joy,” Luke 5:17–26, 7:11–17,"), _c('br'), _vm._v("\n\t\t\t\t\t   13:11–17, 17:11–19, 18:35–43; Acts 3:1–10, 4:21"), _c('br'), _vm._v("\n\t\t\t\t\t   Pepperdine University, Malibu, CA, 2007")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#pz89-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kasey McCollum,")]), _vm._v(" “The Unveiling,” Isa. 25:1–10"), _c('br'), _vm._v("\n\t\t\t\t\t   Methodist Dallas Medical Center, Dallas, TX, 2008")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#pz95-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Melanie Fudge Simpson,")]), _vm._v(" “The Heart of Worship,” Gen. 1:26–28, et al."), _c('br'), _vm._v("\n\t\t\t\t\t   Bering Drive Church of Christ, Houston, TX, 2009")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#pz105-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeanene Perkins Reese,")]), _vm._v(" “How Can I Be Holy When I’m So Human?” 1 Peter"), _c('br'), _vm._v("\n\t\t\t\t\t   Wood Mountain Alliance Church, Glentworth, Saskatchewan, Canada, 2010")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#pz113-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("D’Esta Love,")]), _vm._v(" “We Beheld His Glory,” John 2:1–11; 1:14, 16"), _c('br'), _vm._v("\n\t\t\t\t\t   Manhattan Church of Christ, Manhattan, NY, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#pz121-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Charme Robarts,")]), _vm._v(" “Them and Us,” Matt. 13:3–9"), _c('br'), _vm._v("\n\t\t\t\t\t   First United Methodist Church, Fort Worth, TX, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#pz129-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jo-Anne Fleming,")]), _vm._v(" “The Story of Ruth and Naomi,” Ruth 1:20–21"), _c('br'), _vm._v("\n\t\t\t\t\t   Beamsville Church of Christ, Beamsville, Ontario, Canada, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#pz139-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Shelly Evans Cox,")]), _vm._v(" “Peter and Judas: A Lenten Homily,” Matt. 26:15, 74"), _c('br'), _vm._v("\n\t\t\t\t\t   Culver Palms Church of Christ, Los Angeles, CA, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#pz145-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ashley Gay,")]), _vm._v(" “Being a(t) Home, in Christ,” 1 Pet. 2:2–10; Acts 7:54–60;"), _c('br'), _vm._v("\n\t\t\t\t\t   Psalm 31:1–5; John 14:1–14"), _c('br'), _vm._v("\n\t\t\t\t\t   Brookline Church of Christ, Brookline, MA, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#pz155-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Glynnis Fleming,")]), _vm._v(" “Living with an Organic View of the Scriptures,” John 4:1–42, et\n\t\t\t\t\tal."), _c('br'), _vm._v("\n\t\t\t\t\t   Beamsville Church of Christ, Beamsville, Ontario, Canada, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#pz161-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Natalie Magnusson,")]), _vm._v(" “Advent: A Time of Waiting,” John 1:6–9, 19–34"), _c('br'), _vm._v("\n\t\t\t\t\t   Rochester College, Rochester Hills, MI, 2011")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#pz169-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amy Bost Henegar,")]), _vm._v(" “The Gospel of Gratitude,” Luke 17:11–19"), _c('br'), _vm._v("\n\t\t\t\t\t   Seaver College, Pepperdine University, Malibu, CA, 2012")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#pz177-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Naomi Walters,")]), _vm._v(" “The Jar of Meal Will Not Be Emptied,” 1 Kings 17:7–16"), _c('br'), _vm._v("\n\t\t\t\t\t   Stamford Church of Christ, Stamford, CT, 2012")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#pz183-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cynthia Michaud Ownby,")]), _vm._v(" “Crash Helmets,” Acts 2:1–12; Rom. 8:22–27"), _c('br'), _vm._v("\n\t\t\t\t\t   Bering Drive Church of Christ, Houston, TX, 2012 ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#pz191-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Claire Davidson Frederick,")]), _vm._v(" “From Marginal to Redeemed, from Empty to Full,”"), _c('br'), _vm._v("\n\t\t\t\t\t   Ruth 3:1–5; 4:13–17"), _c('br'), _vm._v("\n\t\t\t\t\t   Northwest Christian Church (Disciples), Arlington, TX, 2012")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#pz199-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jennifer Hale Christy,")]), _vm._v(" “Friends Don’t Let Friends . . .” Mark 10:17–31"), _c('br'), _vm._v("\n\t\t\t\t\t   Camarillo Church of Christ, Camarillo, CA, 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#pz207-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Sara Gaston Barton,")]), _vm._v(" “The Confining Mold of This Present Age,” Rom. 1:1–2"), _c('br'), _vm._v("\n\t\t\t\t\t   East County Church of Christ, Gresham, OR, 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#pz215-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Angela A. Ravin-Anderson,")]), _vm._v(" “Get to Know Your Neighbor,” John 1:1–18"), _c('br'), _vm._v("\n\t\t\t\t\t   Heights Church of Christ, Houston, TX, 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#pz223-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ann Bayliss,")]), _vm._v(" “Lamentations, the Lost Language of the Church,” Lam. 1:1–17"), _c('br'), _vm._v("\n\t\t\t\t\t   Heights Church of Christ Houston TX 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#pz231-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Paige Cargioli,")]), _vm._v(" “Every Heart a Chasm,” Luke 16:19–31"), _c('br'), _vm._v("\n\t\t\t\t\t   Brookline Church of Christ, Brookline, MA, 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#pz239-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cheryl Russell,")]), _vm._v(" “Sower, Seeds, and Soil,” Luke 8:4–15"), _c('br'), _vm._v("\n\t\t\t\t\t   PUMP Church of Christ, Portland, OR, 2013")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz10-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#pz247-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Harmony Weber,")]), _vm._v(" “Living Love,” John 13:33–38"), _c('br'), _vm._v("\n\t\t\t\t\t   Culver Palms Church of Christ, Los Angeles, CA, 2014")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0